import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    googleSession(sessionId)
      .then((user) => {
        toast.success(`Welcome, ${user.name.split(" ")[0]}`);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/shop", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [googleSession, location.hash, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-app" data-testid="auth-callback">
      <Loader2 className="h-8 w-8 animate-spin text-amber-500" />
      <p className="text-sm text-3">Signing you in with Google…</p>
    </div>
  );
}
